import React from 'react';

import { LENDER_ADDRESS } from '../../constants';
import LenderAddressTextField from './LenderAddressTextField.interstate';

const LenderStreetAddressField = () => (
    <LenderAddressTextField
        id="LenderStreetAddressField"
        dataTestId="lender-street-address"
        label={LENDER_ADDRESS}
        name="lender-street-address"
        field="line1"
    />
);

export default LenderStreetAddressField;
